<template>
  <MainNavbar class="edu-fixed-nav" />
  <PaymentPaypal />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import MainNavbar from "../components/Layouts/MainNavbar.vue";
import PaymentPaypal from "../components/Contact/PaymentPaypal.vue";

export default defineComponent({
  name: "RegisterPage",
  components: {
    MainNavbar,
    PaymentPaypal,
  },
});
</script>
